/* eslint-disable no-confusing-arrow */

/**
 * @flow
 * @author: VaraKumar
 */

import styled from 'react-emotion'

import { Typo13VeryLightBlueTwoDR } from '../../../../../themes/Fonts/Din2014'
import { Typo18VeryLightBlueTwoNBI } from '../../../../../themes/Fonts/Nort'
import Colors from '../../../../../themes/Colors'
import { mobile, tablet, desktop } from '../../../../../utils/mixins'

import CloudinaryS3LazyLoadedImage from '../../../../CloudinaryS3LazyLoadedImage'

export const TextTestimonialContainerWrapper = styled('div')`
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  background-color: ${props =>
    props.isDark ? Colors.lightNavy2 : Colors.azure};
  height: ${props => (props.fillHeight ? 'unset' : '100%')};
  flex: ${props => (props.fillHeight ? 1 : 'unset')};
  ${mobile} {
    margin-bottom: ${props => (props.excludeBottomMargin ? 0 : '12px')};
  }
`

export const TextTestimonialContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  background-color: ${props =>
    props.isDark ? Colors.lightNavy2 : Colors.azure};
  height: 100%;
  ${mobile} {
    padding: 1.429em 1.786em 1.429em 1.786em;
  }
  ${tablet} {
    padding: 0.625em 1.5625em 0.625em 1.5625em;
  }
  ${desktop} {
    padding: 0.625em 1.5625em 0.625em 1.5625em;
  }
`

// // NOTE: Below code commented to hide text animation temporarily
// `
//   ${lgDesktop} {
//     height: ${props =>
//       props.onHovered
//         ? `${props.outerElementHeight}px`
//         : `${props.outerElementHeight}px`};
//     justify-content: flex-start;
//   }
// `

export const TestimonialQuote = styled('div')`
  position: absolute;
  top: 0px;
  ${mobile} {
    right: 1.429em;
  }
  ${tablet} {
    right: 1.25em;
  }
  ${desktop} {
    right: 1.25em;
  }
`

export const QuoteImage = styled(CloudinaryS3LazyLoadedImage)`
  ${mobile} {
    width: 4em;
    height: 2.571em;
  }
  ${tablet} {
    width: 3.5em;
    height: 2.25em;
  }
  ${desktop} {
    width: 3.5em;
    height: 2.25em;
  }
`

export const Heading = styled(Typo18VeryLightBlueTwoNBI)`
  font-family: din-2014;
  font-weight: bold;
  font-style: italic;
  color: ${Colors.veryLightBlueTwo};
  letter-spacing: -0.2px;
  margin: 0;
  ${mobile} {
    font-size: 1.286em;
    line-height: 1.22;
  }
  ${tablet} {
    font-size: 1.125em;
    line-height: 1.22;
  }
  ${desktop} {
    font-size: 1.125em;
    line-height: 1.22;
  }
  letter-spacing: -0.2px;
`
export const HeadingWithoutH2 = styled(Typo18VeryLightBlueTwoNBI)`
  font-family: din-2014;
  font-weight: bold;
  font-style: italic;
  color: ${Colors.veryLightBlueTwo};
  letter-spacing: -0.2px;
  margin: 0;
  ${mobile} {
    font-size: 1.286em;
    line-height: 1.22;
  }
  ${tablet} {
    font-size: 1.125em;
    line-height: 1.22;
  }
  ${desktop} {
    font-size: 1.125em;
    line-height: 1.22;
  }
`

// // NOTE: Below code commented to hide text animation temporarily
//
// `
//   ${lgDesktop} {
//     padding-top: ${props =>
//       props.onHovered
//         ? '0'
//         : `${(props.outerElementHeight - (props.headingHeight + 20)) / 2}px`};
//     padding-bottom: ${props =>
//       props.onHovered
//         ? '0'
//         : `${(props.outerElementHeight - (props.headingHeight + 20)) / 2}px`};
//     transition: ${props =>
//       props.onHovered
//         ? 'padding-top 0.4s ease-in-out,padding-bottom 0.4s ease-in-out'
//         : 'padding-top 0.4s ease-in-out,padding-bottom 0.4s ease-in-out'};
//   }
// `

export const TestimonialText = styled(Typo13VeryLightBlueTwoDR)`
  font-family: din-2014;
  color: ${Colors.veryLightBlueTwo};
  padding-top: 3px;
  ${mobile} {
    font-size: 0.929em;
    line-height: 1.46;
    margin-top: 4px;
  }
  ${tablet} {
    font-size: 0.8125em;
    line-height: 1.46;
    margin-top: 0.692em;
  }
`

// // NOTE: Below code commented to hide text animation temporarily
// `  ${lgDesktop} {
//     opacity: ${props => (props.onHovered ? 1 : 0)};
//     transition: ${props =>
//       props.onHovered
//         ? 'opacity 0.4s ease-in-out'
//         : 'opacity 0.4s ease-in-out'};
//   }
// `



// WEBPACK FOOTER //
// ./src/components/Home/TestimonialSection/TestimonialComponents/TextTestimonial/styledComponents.js